import {
  Body,
  BTCValue,
  Cell,
  CellTitle,
  CellValue,
  Footer,
  LocalValue,
  Row,
  Title,
} from "./styles";
import { Copy } from "../../../../../components/Copy";
import { FormButton } from "../../../../../components/Form";
import {
  getCashflowListSGT,
  statusSZTConvert,
  typeConvertSGT,
} from "../../../../../services/app";
import React, { useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";
import { useApp } from "../../../../../contexts";
import ModalCancel from "../cancel";
import Modal from "../../../../../components/Modal/Modal";
import {
  DesktopContainer,
  MobileContainer,
} from "../../../../../components/Container";
import NumberFormat from "react-number-format";
import ModalWithdraw from "../../../../withdraw/modal";
import styled from "styled-components";
import {
  decimalSeparatorByCurrency,
  thousandSeparatorByCurrency,
} from "../../../../../utils/Currency";
import { useSearchParams } from "react-router-dom";
function DetailSGT(props) {
  const { T, setLoading, setAlert, getCurrency } = useApp();
  const [searchParams, setSearchParams] = useSearchParams();
  const id = props.id;
  const onClose = props.onClose;
  const contentRef = useRef();
  const positionScrollRef = useRef(0);
  const [row, setRow] = useState();

  const [mode, setMode] = useState("detail");
  useEffect(() => {
    const modeParam = searchParams.get("mode");
    if (modeParam) {
      setMode(modeParam);
    }
  }, [searchParams]);

  const ModalContainer = styled(Modal.Container)`
    padding: 52px 59px 55px 70px;
    background: #f5f5f5;
    box-shadow: 0px 0px 36px rgba(0, 0, 0, 0.25);
    border-radius: 64px;
    width: 850px;
    @media (max-width: 1024px) {
      box-shadow: 0px 16px 36px rgba(104, 109, 132, 0.4157);
      border-radius: 32px;
      padding: 42px 27px 43px 28px;
    }
  `;

  const ContentWaper = styled.div`
    max-height: 80vh;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  `;

  useEffect(() => {
    loadData().then();
  }, [id]);

  const convertData = () => {
    const item = row;
    console.log(row);
    let status = statusSZTConvert(item);
    let itemType = typeConvertSGT(item);
    return item
      ? {
          ...item,
          id: item.id,
          transactionId: item.transactionId,
          type: itemType,
          typeCode: item.type,
          coin: item.dest_currency_code,
          coinFrom: item.from_currency_code,
          amount: item.amount,
          status: status,
          statusCode: item.status,
          time: moment(item.created_time).format("YYYY/MM/DD HH:mm:ss"),
        }
      : {};
  };

  const loadData = async () => {
    setLoading(true);
    let result = null;
    const resultList = await getCashflowListSGT({
      transactionId: id,
    });
    if (resultList.data?.data?.cashflows?.count > 0) {
      const transData = resultList.data?.data?.cashflows.rows || [];
      const transactionMain = transData.find((trans) => trans.type === 34);
      const transactionFee = transData.find((trans) => trans.type === 37);
      const transactionRemain = transData.find((trans) => trans.type === 36);
      const transaction = {
        ...transactionMain,
        transactionId: transactionMain.transactionId,
        transactionCode: transactionMain.transactionCode,
        from_currency_code: "SGT",
        dest_currency_code: "SGT",
        typeCode: transactionMain.type,
        coinFrom: "SGT",
        amount: Math.abs(transactionMain.amount || 0),
        toAmount: Math.abs(transactionMain.amount || 0),
        statusCode: transactionMain.status,
        created_time: transactionMain.createTime,
        isRefund: !!transactionRemain,
        refundAmount: Math.abs(transactionRemain?.amount || 0),
        feeAmount: Math.abs(transactionFee.amount || 0),
      };
      result = {
        status: 200,
        data: {
          data: {
            transaction: {
              ...transaction,
            },
          },
        },
      };
    } else {
      result = {
        status: 400,
        data: {
          error: {
            message: "Some error happened. Please try again later.",
          },
        },
      };
    }
    setLoading(false);
    if (result.status === 200) {
      const item =
        {
          ...result?.data?.data?.transaction,
        } || {};
      setRow(item);
    } else {
      setAlert({
        type: "error",
        text: result?.data?.error?.message || "",
      });
      onClose();
    }
    setLoading(false);
  };

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = positionScrollRef.current;
    }
  });

  const value = useMemo(() => {
    return convertData() || {};
  }, [row]);

  if (mode === "confirm") {
    return (
      <ModalWithdraw
        onClose={(value) => {
          setSearchParams(
            (prev) => {
              const params = new URLSearchParams(prev);
              params.set("mode", "detail");
              return params;
            },
            {
              replace: true,
            }
          );
          if (value) {
            setAlert({
              type: value,
              text:
                value === "success"
                  ? T("Withdrawal request has been created")
                  : T("Failed to create a withdrawal request"),
            });
            if (value === "success") {
              onClose();
            }
          }
        }}
        value={value}
      />
    );
  }

  return (
    <Modal>
      <Modal.ModalBg onClose={onClose} />
      <ModalContainer onClose={onClose} ref={contentRef}>
        <ContentWaper
          onScroll={(e) => {
            positionScrollRef.current = e.target?.scrollTop;
          }}
          ref={contentRef}
          id="content-detail"
        >
          {mode === "detail" ? (
            <>
              <Title>{T("Transaction details")}</Title>
              {row ? (
                <>
                  <Body className={``}>
                    <Row className="lg:w-[266px]">
                      <Cell>
                        <CellTitle>{T("Transaction ID")}</CellTitle>
                        <CellValue className="transactionId">
                          <Copy
                            splitFont={25}
                            splitEnd={0}
                            numDot={3}
                            text={value?.transactionCode}
                          />
                        </CellValue>
                      </Cell>
                      <MobileContainer>
                        <Cell>
                          <CellTitle>{T("Time")}</CellTitle>
                          <CellValue>{value.time}</CellValue>
                        </Cell>
                      </MobileContainer>
                      <MobileContainer>
                        <Cell>
                          <CellTitle>{T("To Address")}</CellTitle>
                          <CellValue>
                            {value?.toAddress ? (
                              <Copy
                                splitFontLg={18}
                                splitFont={16}
                                splitEnd={5}
                                numDot={3}
                                text={value?.toAddress}
                              />
                            ) : null}
                          </CellValue>
                        </Cell>
                      </MobileContainer>
                      <MobileContainer>
                        <Cell>
                          <CellTitle>{T("Network")}</CellTitle>
                          <CellValue className="capitalize">
                            {T("Polygon Main Network")}
                          </CellValue>
                        </Cell>
                      </MobileContainer>
                      <Cell>
                        <CellTitle>{T("Type")}</CellTitle>
                        <CellValue className="capitalize">
                          {T(value.type)}
                        </CellValue>
                      </Cell>

                      <Cell>
                        <CellTitle>{T("Credit")}</CellTitle>
                        <CellValue className="capitalize">
                          {T("SGT (SGT Walk- to - earn)")}
                        </CellValue>
                      </Cell>

                      <Cell>
                        <CellTitle>{T("Withdrawn Amount")}</CellTitle>
                        <CellValue>
                          <NumberFormat
                            value={value?.amount + value?.feeAmount}
                            displayType={"text"}
                            suffix=" SGT"
                            thousandSeparator={thousandSeparatorByCurrency(
                              getCurrency()
                            )}
                            decimalSeparator={decimalSeparatorByCurrency(
                              getCurrency()
                            )}
                            decimalScale={8}
                          />
                        </CellValue>
                      </Cell>
                      <Cell>
                        <CellTitle>{T("Status")}</CellTitle>
                        <CellValue>
                          {value?.isRefund ? T("Failed") : T(value.status)}
                        </CellValue>
                      </Cell>
                    </Row>
                    <Row className="lg:w-[399px]">
                      <DesktopContainer>
                        <Cell>
                          <CellTitle>{T("Time")}</CellTitle>
                          <CellValue>{value.time}</CellValue>
                        </Cell>
                      </DesktopContainer>
                      <DesktopContainer>
                        <Cell>
                          <CellTitle>{T("To Address")}</CellTitle>
                          <CellValue>
                            {value?.toAddress ? (
                              <Copy
                                splitFontLg={18}
                                splitFont={16}
                                splitEnd={5}
                                numDot={3}
                                text={value?.toAddress}
                              />
                            ) : null}
                          </CellValue>
                        </Cell>
                      </DesktopContainer>
                      <DesktopContainer>
                        <Cell>
                          <CellTitle>{T("Network")}</CellTitle>
                          <CellValue className="capitalize">
                            {T("Polygon Main Network")}
                          </CellValue>
                        </Cell>
                      </DesktopContainer>

                      <Cell>
                        <CellTitle>{T("Fee")}</CellTitle>
                        <CellValue>
                          <NumberFormat
                            value={value?.feeAmount ?? 0}
                            displayType={"text"}
                            suffix=" SGT"
                            thousandSeparator={thousandSeparatorByCurrency(
                              getCurrency()
                            )}
                            decimalSeparator={decimalSeparatorByCurrency(
                              getCurrency()
                            )}
                            decimalScale={8}
                          />
                        </CellValue>
                      </Cell>
                      {value?.isRefund ? (
                        <>
                          <Cell>
                            <CellTitle>{T("Refund amount")}</CellTitle>
                            <CellValue>
                              <NumberFormat
                                value={value?.refundAmount}
                                displayType={"text"}
                                suffix=" SGT"
                                thousandSeparator={thousandSeparatorByCurrency(
                                  getCurrency()
                                )}
                                decimalSeparator={decimalSeparatorByCurrency(
                                  getCurrency()
                                )}
                                decimalScale={8}
                              />
                            </CellValue>
                          </Cell>
                        </>
                      ) : (
                        <></>
                      )}
                    </Row>
                  </Body>
                </>
              ) : null}
              <Footer className="pb-2">
                <FormButton style={{ maxWidth: 300 }} onClick={onClose}>
                  {T("OK")}
                </FormButton>
              </Footer>
            </>
          ) : null}
          {mode === "cancel" ? (
            <ModalCancel
              onClose={(event) => {
                if (event) {
                  onClose(event);
                } else {
                  setSearchParams(
                    (prev) => {
                      const params = new URLSearchParams(prev);
                      params.set("mode", "detail");
                      return params;
                    },
                    {
                      replace: true,
                    }
                  );
                }
              }}
              value={row}
            />
          ) : null}
        </ContentWaper>
      </ModalContainer>
    </Modal>
  );
}

export default React.memo(DetailSGT, () => false);
